import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { id: 'Artboard-32' }),
  React.createElement('path', { d: 'M26 25.25H6a2.65 2.65 0 0 1-2.65-2.65V9.4A2.65 2.65 0 0 1 6 6.75h20a2.65 2.65 0 0 1 2.65 2.65v13.2A2.65 2.65 0 0 1 26 25.25zM6 8.05A1.36 1.36 0 0 0 4.65 9.4v13.2A1.36 1.36 0 0 0 6 24h20a1.36 1.36 0 0 0 1.35-1.35V9.4A1.36 1.36 0 0 0 26 8.05z' }),
  React.createElement('path', { d: 'M6.58 11.41h18.84v1.3H6.58zM6.58 15.35h18.84v1.3H6.58zM6.58 19.29h10.29v1.3H6.58z' })
));